export const ButtonPrimary = ({ text, onClick, disabled = false, style = {} }) => {
    return <button type="button" className="btn btn-primary" style={style} onClick={onClick} disabled={disabled}>{text}</button>
}

export const ButtonPrimarySm = ({ text, onClick, disabled = false, style = {} }) => {
    return <button type="button" className="btn btn-sm btn-primary" style={style} onClick={onClick} disabled={disabled}>{text}</button>
}

export const ColFlex = ({ style = {}, children }) => {
    return <div className="col" style={style}>{children}</div>
}

export const Col1 = ({ style = {}, children }) => {
    return <div className="col-lg-1 col-sm-12" style={style}>{children}</div>
}

export const Col2 = ({ style = {}, children }) => {
    return <div className="col-lg-2 col-sm-12" style={style}>{children}</div>
}

export const Col3 = ({ style = {}, children }) => {
    return <div className="col-lg-3 col-sm-12" style={style}>{children}</div>
}

export const Col4 = ({ style = {}, children }) => {
    return <div className="col-lg-4 col-sm-12" style={style}>{children}</div>
}

export const Col5 = ({ style = {}, children }) => {
    return <div className="col-lg-5 col-sm-12" style={style}>{children}</div>
}

export const Col6 = ({ style = {}, children }) => {
    return <div className="col-lg-6 col-sm-12" style={style}>{children}</div>
}

export const Col7 = ({ style = {}, children }) => {
    return <div className="col-lg-7 col-sm-12" style={style}>{children}</div>
}

export const Col8 = ({ style = {}, children }) => {
    return <div className="col-lg-8 col-sm-12" style={style}>{children}</div>
}

export const Col9 = ({ style = {}, children }) => {
    return <div className="col-lg-9 col-sm-12" style={style}>{children}</div>
}

export const Col10 = ({ style = {}, children }) => {
    return <div className="col-lg-10 col-sm-12" style={style}>{children}</div>
}

export const Col11 = ({ style = {}, children }) => {
    return <div className="col-lg-11 col-sm-12" style={style}>{children}</div>
}

export const Col12 = ({ style = {}, children }) => {
    return <div className="col-12" style={style}>{children}</div>
}